// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.special-effects-panel {
  width: 164px;
  height: 240px;
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
  background-color: white;
}
.special-effects-panel .font-special-effects-item {
  width: 48px;
  height: 48px;
  background: rgba(0, 0, 0, 0.04);
  margin: 2px;
}
.special-effects-panel .font-special-effects-item-selected {
  outline: 2px solid #4a90e2;
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/FontSpecialEffetcs/SpecialEffectsSelectPanel/SpecialEffectsSelectPanel.less"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;AACJ;AAPA;EASQ,WAAA;EACA,YAAA;EACA,+BAAA;EACA,WAAA;AACR;AAbA;EAgBQ,0BAAA;AAAR","sourcesContent":[".special-effects-panel {\n    width: 164px;\n    height: 240px;\n    overflow: auto;\n    display: flex;\n    flex-wrap: wrap;\n    background-color: white;\n\n    .font-special-effects-item {\n        width: 48px;\n        height: 48px;\n        background: rgba(0, 0, 0, 0.04);\n        margin: 2px;\n    }\n\n    .font-special-effects-item-selected {\n        outline: 2px solid #4a90e2;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
